import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "filterPurchaseHistory" })
export class FilterPurchaseHistory implements PipeTransform {
	transform(history: Array<IPurchaseHistoryModel>, searchTerm: string) {
		if(searchTerm && searchTerm.length > 2)
			return history.filter((purchase: IPurchaseHistoryModel) =>
				(`${purchase.title}${purchase.firstName}${purchase.lastName}${purchase.approver}${purchase.status}${purchase.fromStatus}${purchase.departmentName}${purchase.managerName}
					${purchase.shippingMethodName}${purchase.id}`).toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 || this.checkItems(purchase.items, searchTerm)
			);

		return history;
	}

	checkItems(items: Array<IItemModal>, searchTerm: string): boolean {
		return items.filter((item: IItemModal) => (`${item.description}${item.suggestedSupplier}${item.poNumber}`).toLowerCase().indexOf(searchTerm.toLowerCase()) > -1).length > 0;
	}
}

@Pipe({ name: "sortBy" })
export class SortPipe implements PipeTransform {
	transform(array: Array<any>, columnName: string, isDesc: boolean): Array<string> {
		if(!columnName)
			return array;

		let desc = isDesc ? -1 : 1;

		array.sort((a: any, b: any) => {
			if(typeof a[columnName] === "number") {
				if(a[columnName] < b[columnName])
					return desc * -1;
				else if(a[columnName] > b[columnName])
					return desc;
			} else {
				if((a[columnName] === null ? "" : a[columnName].toString().toLowerCase()) < (b[columnName] === null ? "" : b[columnName].toString().toLowerCase()))
					return desc * -1;
				else if((a[columnName] === null ? "" : a[columnName].toString().toLowerCase()) > (b[columnName] === null ? "" : b[columnName].toString().toLowerCase()))
					return desc;
			}

			return 0;
		});

		return array;
	}
}

@Pipe({ name: "dateFormatter" })
export class DatePipe implements PipeTransform {
	transform(value: string) {
		if(!value)
			return value;

		var t = new Date(value.toString().substring(0, 10));
		var d = `${t.getUTCMonth() + 1}/${t.getUTCDate()}/${t.getUTCFullYear()}`;
		return d;
	}
}

@Pipe({ name: "highlight" })
export class HighlightPipe implements PipeTransform {
	transform(text: string): string {
		let prepend = "";

		if(!text)
			return text;

		var expression = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
		var regex = new RegExp(expression);
		
		return text.replace(regex, (match: string) => {

			if(!match.startsWith("http"))
				prepend = "//";

			return `<a href="${prepend}${match}" target="_blank">${match}</a>`;
		});
	}
}

@Pipe({ name: "urlEncode" })
export class UrlEncode implements PipeTransform {
	transform(text: string): string {
		return encodeURIComponent(text);
	}
}